var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditGuestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edcit-guest-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15182",
    "data-name": "Group 15182",
    transform: "translate(-710.771 -434.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33326",
    "data-name": "Path 33326",
    d: "M715,457.711a.8.8,0,0,1,.861-.711h13.769a.724.724,0,1,1,0,1.421H715.861A.8.8,0,0,1,715,457.711Z",
    transform: "translate(0 -2.544)",
    fill: "#23262f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33327",
    "data-name": "Path 33327",
    d: "M726.776,438.873a.836.836,0,0,0-1.215,0l-.755.784,3.081,3.2.755-.783a.917.917,0,0,0,0-1.261Zm-8.414,7.473,5.229-5.428,3.081,3.2-5.229,5.427Zm-1.215,1.261-.43.446v3.2H719.8l.43-.446Zm7.2-9.995a2.51,2.51,0,0,1,3.644,0l1.866,1.936a2.749,2.749,0,0,1,0,3.784l-8.843,9.18a1.687,1.687,0,0,1-1.215.523h-3.081A1.752,1.752,0,0,1,715,451.251v-3.2a1.818,1.818,0,0,1,.5-1.261Z",
    transform: "translate(0 0)",
    fill: "#23262f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGuestIcon);
export default __webpack_public_path__ + "static/media/edit-guest-icon.4abc9ff9b7f4a360d7b7594e7b5a5640.svg";
export { ForwardRef as ReactComponent };